<div>
    <ng-container *ngIf= "!hideWorkOrder()" >
    <label><strong>Work Order</strong></label>
    <ng-select style="margin-bottom: 12px"
               [items]="workOrderList() || []"
               bindLabel="DisplayValue"
               [clearable]="true"
               [typeahead]="workOrderInput$"
               [ngModel]="selectedWorkOrder()"
               (change)="workOrderChanged($event)"
               [searchable]="true"
               typeToSearchText="Please enter 3 or more characters"
               placeholder="Type to search...">
    </ng-select>

    <label><strong>Work Order Item</strong></label>
    <ng-select style="margin-bottom: 12px;"
               [items]="workOrderItemsList() || []"
               bindLabel="DisplayValue"
               [clearable]="false"
               [ngModel]="selectedWorkOrderItem()"
               dropdownPosition="bottom"
               (change)="workOrderItemChanged($event)"
               [searchable]="true">
    </ng-select>
    </ng-container>
    <label><strong>Equipment</strong></label>
    <ng-select style="margin-bottom: 12px;"
               [items]="equipmentList() || []"
               bindLabel="DisplayValue"
               [clearable]="true"
               [typeahead]="equipmentInput$"
               [ngModel]="selectedEquipment()"
               (change)="equipmentChanged($event)"
               [searchable]="true"
               typeToSearchText="Please enter 3 or more characters"
               placeholder="Type to search...">
    </ng-select>

    <label><strong>Cost Code</strong></label>
    <ng-select style="margin-bottom: 12px;"
               [items]="costCodeList() || []"
               bindLabel="DisplayValue"
               [clearable]="false"
               [ngModel]="selectedCostCode()"
               dropdownPosition="bottom"
               (change)="costCodeChanged($event)"
               [searchable]="true">
    </ng-select>
</div>